import { Injectable } from '@angular/core';

/**
 * When "back" is used from the order v2 embedded toolbar, {@link OrderDetailComponent}
 * must still skip clearing the order list filter (same as the shell back button).
 */
@Injectable({ providedIn: 'root' })
export class OrderDetailBackIntentService {
  private skipListFilterClearOnce = false;

  markBackFromEmbeddedOrderToolbar(): void {
    this.skipListFilterClearOnce = true;
  }

  consumeSkipListFilterClear(): boolean {
    if (!this.skipListFilterClearOnce) {
      return false;
    }
    this.skipListFilterClearOnce = false;
    return true;
  }
}
